import { BaseQueryFn, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import configurationSlice from "./configurationSlice";
import { RootState } from "./store";

export function unauthenticatedApiBaseQuery(apiPath?: string): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> {
  return async (args, store, extraOptions) => {
    const { apiBaseUrl } = (store.getState() as RootState)[configurationSlice.name];

    const rawBaseQuery = fetchBaseQuery({
      baseUrl: new URL(apiPath ?? "", apiBaseUrl).href,
    });

    return rawBaseQuery(args, store, extraOptions);
  };
}

function prepareHeadersForAgentCopilot(headers: Headers, { getState }: { getState(): unknown }): Headers {
  const { accessToken } = (getState() as RootState).agentCopilotAccess;

  if (!accessToken)
    throw new Error("Empty 'token' found in state.");

  headers.set("authorization", `Bearer ${accessToken}`);

  return headers;
}

export function agentCopilotApiBaseQuery(apiPath?: string): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> {
  return async (args, store, extraOptions) => {
    const { apiBaseUrl } = (store.getState() as RootState)[configurationSlice.name];

    const rawBaseQuery = fetchBaseQuery({
      baseUrl: new URL(apiPath ?? "", apiBaseUrl).href,
      prepareHeaders: prepareHeadersForAgentCopilot,
    });

    return rawBaseQuery(args, store, extraOptions);
  };
}

export function post<T>(url: string, body: NonNullable<T>): FetchArgs {
  return {
    url,
    method: "POST",
    body,
  };
}
